module.exports = function (M) {
  'use strict';

  return {
    checkTracking: function (element) {
      if (M.tracking && M.tracking[element]) {
        return true;
      }
      return false;
    },
    getTrackingAction: function (element) {
      var action = M.tracking[element]['action'];
      delete M.tracking[element]['action'];

      return action;
    },
    formatTracking: function (element, uniqueIdentifier) {
      if (uniqueIdentifier) {
        M.tracking[element][uniqueIdentifier] =
          this.getTrackingId(uniqueIdentifier);
      }
    },
    getTrackingId: function (uniqueIdentifier) {
      var uId = localStorage.getItem(uniqueIdentifier);
      if (!uId) {
        uId = uuidV4();
        try {
          localStorage.setItem(uniqueIdentifier, uId);
        } catch (e) {}
      }
      return uId;
    },
    removeTrackingId: function (uniqueIdentifier) {
      localStorage.removeItem(uniqueIdentifier);
    },
  };
};
